<template>
    <div class="border bg-gray-100 rounded p-4 mt-3">
        <div class="mb-4">List with images</div>
        <div class="w-full">
            <Select
                label="Headline Type"
                name="headline_type"
                v-model="headline_type"
                class="ml-3"
                :options="[
                    { value: null, name: '' },
                    { value: 'H2', name: 'H2' },
                    { value: 'H3', name: 'H3' },
                    { value: 'H4', name: 'H4' },
                ]"
                @input="headlineTypeChanged($event)"
            />
        </div>
        <draggable
            v-model="data"
            ghost-class="bg-gray-200"
            handle=".handle"
            @choose="froalaStore.disableFroala = true"
            @unchoose="froalaStore.disableFroala = false"
        >
            <div v-for="(item, index) in data"
                 :key="`listWithImages-${item.id || item.uuid}`"
                 class="relative mt-2 max-w-8xl item">
                <div class="items-center">
                    <input-text
                        name="headline"
                        label="Headline"
                        class="ml-3 mb-3 w-full"
                        v-model="item.headline"
                        :maxlength=255
                    />

                    <rocket-link
                        class="ml-3 mb-3"
                        label="Headline Link"
                        :hide-link-text="true"
                        :language="language"
                        v-model="item.headline_link"
                        :resettable="true"
                    />

                    <media-reference
                        :name="`list_with_images_[${index}][image]`"
                        v-model="item.image"
                        :language="language"
                        class="ml-3 w-full"
                        @input="updateImage(index, $event)"
                    />

                    <rocket-link
                        class="ml-3 mb-3"
                        label="Image Link"
                        :hide-link-text="true"
                        :language="language"
                        v-model="item.image_link"
                        :resettable="true"
                    />

                    <div class="ml-3 mb-3 w-full">
                        <input-rich-text
                            :name="`list_with_images_[${index}][content]`"
                            v-model="item.content"
                            :maxlength=5000
                            :language="language"
                            class="w-full"
                        />
                    </div>
                    <div class="ml-3 handle inline-block" title="Drag to reorder items">
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 17l-4 4m0 0l-4-4m4 4V3" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7l4-4m0 0l4 4m-4-4v18" />
                        </svg>
                    </div>
                    <div
                        @click="handleDelete(index)"
                        class="ml-3 cursor-pointer inline-block"
                    >
                        <svg class="w-8 h-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                    </div>
                </div>
            </div>
            <button slot="footer"
                class="mt-6 text-indigo-600 hover:text-indigo-900"
                type="button"
                @click="AddItem"
            >
                + Add item
            </button>
        </draggable>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import siteLanguage from '../../config/siteLanguage'
import RocketLink from "../Link/RocketLink.vue";
import {useFroalaStore} from "../../stores/froala";
import {v4 as uuidv4} from "uuid";

export default {
    components: {RocketLink, draggable },
    name: "ListWithImages",
    props: {
        value: Array,
        contentBlockId: Number,
        contentSectionId: Number,
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            },
        },
    },
    data() {
        return {
            headline_type: this.value[0]?.headline_type ? this.value[0].headline_type : null,
            data: this.value[0]?.content ?  this.value : [this.defaultData()],
            froalaStore: useFroalaStore(),
        };
    },
    updated() {
        this.$emit("input", this.data);
    },
    methods: {
        defaultData() {
            return {
                uuid: uuidv4(),
                content: "",
                headline: "",
                headline_link: {},
                image: null,
                image_id: null,
                image_link: {},
                headline_type: this.headline_type ?? null,
            }
        },
        AddItem(e) {
            e.preventDefault();
            this.data.push(this.defaultData());
        },
        handleDelete: function (indexOfItemToDelete) {
            if (confirm('Are you sure you want to remove this item?')) {
                this.data.splice(indexOfItemToDelete, 1);
            }
        },
        updateImage: function (index, image) {
            this.$set(this.data, index, Object.assign(this.data[index], {image_id: (image && image.id) ? image.id : null}));
        },
        headlineTypeChanged: function (headlineType) {
            this.data = this.data.map(item => { item.headline_type = headlineType; return item; });
        }
    },
    watch: {
        value: function (newValue) {
            this.data = newValue;
        }
    }
};
</script>
